import React, {useEffect, useMemo, useRef, useState} from "react";
import FileRow from "../fileRow/fileRow";
import functions from "../../../../utils/functionsFirebase";
import {ConfirmationModal, Spinner} from "../../../shared";
import {FormattedMessage, useIntl} from "react-intl";
import {toast} from "react-toastify";
import drive from "../../index";
import {useDispatch, useSelector} from "react-redux";
import './fileTable.css'
import {checkNode, isMobileDevice} from "../../../../utils/utils";
import UploadUtils from "../../uploadUtils/uploadUtils";
import useDownloadStore from "../../../../store/downloadStore";
import {useLocation} from "react-router-dom";

function FilesTable({files, folders, loading, onChangeFolder, onGoBack, onOpenFile, draggingAnything}) {
    const {addFileToQueue} = useDownloadStore(state => state.actions);

    const dispatch = useDispatch();
    const intl = useIntl();
    const location = useLocation();

    const contextualMenu = useRef(null);
    const uploadUtils = useRef(null);

    const [selectedFiles, setSelectedFiles] = useState([]);
    let [loadingFiles, setLoadingFiles] = useState([]);
    const [openedToast, setOpenedToast] = useState(null);
    const [showContextMenu, setShowContextMenu] = useState(false);
    const [activeContext, setActiveContext] = useState(null);
    const [fileChangingName, setFileChangingName] = useState(null);
    const [movingItems, setMovingItems] = useState(null);
    const [draggingItem, setDraggingItem] = useState(null);
    const [prevScrollPosition, setPrevScrollPosition] = useState(0);

    const folderTree = useSelector(drive.selectors.getFolderTree)

    useEffect(() => {


        return () => {
            toast.dismiss(openedToast);
            setOpenedToast(null);
        };
    }, []);

    useEffect(() => {
        const handleButtonClick = () => {
            setMovingItems(true);
        };

        const showToast = (content) => {
            return toast.info(content,
                {
                    closeButton: false, // Disable the close button
                    autoClose: false, // Disable auto-closing the toast
                    closeOnClick: false,
                    draggable: false,
                    icon: false
                }
            );
        };
        if (selectedFiles.length > 0) {
            const filesFiltered = selectedFiles.filter(x => x.fileName);
            const foldersFiltered = selectedFiles.filter(x => x.folderName);
            const content = (
                <div>
                    <div className="d-flex flex-row justify-content-center">
                        <div className="col-5 d-flex justify-content-end">
                            <div>
                                {filesFiltered.length} <FormattedMessage id="drive.files-selected-info"/>
                            </div>
                        </div>
                        &nbsp;/&nbsp;
                        <div className="col-5">
                            {foldersFiltered.length} <FormattedMessage id="drive.folders-selected-info"/>
                        </div>
                    </div>
                    <hr/>
                    <button id={"recycleBinModalButton"} style={{display: 'none'}} data-bs-toggle="modal"
                            data-bs-target={"#recycleBinModal"}/>
                    <div className="d-flex flex-row gap-2 justify-content-around mb-2">
                        <button className="btn btn-sm btn-outline-secondary"
                                onClick={cancelSelected}><FormattedMessage id="modal.cancel"/>
                            <i className="fa-solid fa-xmark ms-2"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-secondary"
                                onClick={handleButtonClick}><FormattedMessage id="drive.move-selected"/>
                            <i className="fa-regular fa-folder-open ms-2"></i>
                        </button>
                        {foldersFiltered.length === 0 &&
                            <button className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleMoveItemsToTrash()}>
                                <FormattedMessage id="drive.delete-selected"/>
                                <i className="fa-solid fa-trash ms-2"></i>
                            </button>}
                        {foldersFiltered.length > 0 &&
                            <button className="btn btn-sm btn-outline-danger col-4"
                                    data-bs-toggle="modal"
                                    data-bs-target={"#confirmMoveTrash"}>
                                <FormattedMessage id="drive.delete-selected"/>
                                <i className="fa-solid fa-trash ms-2"></i>
                            </button>}
                    </div>
                    <div className="d-flex flex-row justify-content-around gap-2">
                        <button className="btn btn-sm btn-outline-secondary"
                                onClick={selectAllFiles}><FormattedMessage id="drive.select-all-files"/>
                            <i className="fa-solid fa-file ms-1"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-secondary"
                                onClick={selectAllFolders}><FormattedMessage id="drive.select-all-folders"/>
                            <i className="fa-solid fa-folder ms-1"></i>
                        </button>
                    </div>
                </div>
            );
            if (openedToast === null) {
                setOpenedToast(showToast(content));
            } else {
                toast.update(openedToast, {
                    render: content,
                })
            }
        } else if (selectedFiles.length === 0) {
            toast.dismiss(openedToast);
            setOpenedToast(null);
        }

    }, [selectedFiles])

    useEffect(() => {

        const handleContextMenu = (event) => {
            event.preventDefault();
            if (showContextMenu) {
                const check = checkNode(event.target, ['fileTable__contextMenu', 'fileTable__filesRows']);
                if (!check) {
                    setShowContextMenu(false);
                    setActiveContext(null);
                    contextualMenu.current.style.left = `-1000px`;
                    contextualMenu.current.style.top = `-1000px`;
                }
            }
        };
        const handlePointerUp = (event) => {
            event.preventDefault();
            if (showContextMenu) {
                const check = checkNode(event.target, ['fileTable__contextMenu']);
                if (!check) {
                    setShowContextMenu(false);
                    setActiveContext(null);
                    contextualMenu.current.style.left = `-1000px`;
                    contextualMenu.current.style.top = `-1000px`;
                }
            }
        };

        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('pointerup', handlePointerUp);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('pointerup', handlePointerUp);
        };
    }, [showContextMenu]);

    useEffect(() => {

        const handleScroll = () => {
            const scrollContainer = document.getElementById('home__scrollContainer');
            const scrollPosition = scrollContainer.scrollTop || scrollContainer.pageYOffset;
            const scrollDifference = Math.abs(scrollPosition - prevScrollPosition); // Diferencia de desplazamiento
            if (scrollDifference >= 5) {
                // Resto de la lógica cuando la diferencia de desplazamiento es mayor o igual a 5
                if (showContextMenu) {
                    setShowContextMenu(false);
                    setActiveContext(null);
                    contextualMenu.current.style.left = `-1000px`;
                    contextualMenu.current.style.top = `-1000px`;
                }
            }
            setPrevScrollPosition(scrollPosition);// Actualizar la posición anterior
        };

        const scrollContainer = document.getElementById('home__scrollContainer');
        scrollContainer.addEventListener('scroll', handleScroll);

        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, [showContextMenu]);

    async function handleMoveGivenItemsToTrash(movedFiles) {
        setFileChangingName(null);
        const filesMoved = [...movedFiles];
        setLoadingFiles(prevState => [...prevState, ...filesMoved]);
        const files = movedFiles.filter(x => x.fileName);
        const folders = movedFiles.filter(x => x.folderName);
        const moveItemsToTrash = functions.httpsCallable("moveItemsToTrash")
        const res = await moveItemsToTrash({files, folders});
        if (res.data.success) {
            dispatch(drive.actions.removedFilesFromFolder(filesMoved));
            dispatch(drive.actions.addFilesToTrash(filesMoved));
            toast.success(intl.formatMessage({id: "drive.removed-items.moved-trash"}));
        }
        setLoadingFiles(prevState => prevState.filter(x => !filesMoved.some(y => y.id === x.id)))
    }

    async function handleMoveGivenItemsToFolder(movedFiles, destFolder) {
        setFileChangingName(null);
        const filesMoved = [...movedFiles];
        setLoadingFiles(prevState => [...prevState, ...filesMoved]);
        const files = movedFiles.filter(x => x.fileName);
        const folders = movedFiles.filter(x => x.folderName);
        const moveItemsToFolder = functions.httpsCallable("moveItemsToFolder")
        const res = await moveItemsToFolder({files, folders, destFolder});
        if (res.data.success) {
            dispatch(drive.actions.removedFilesFromFolder(filesMoved));
            toast.success(intl.formatMessage({id: "drive.moved-items.success"}) + " " + destFolder.folderName);
        }
        setLoadingFiles(prevState => prevState.filter(x => !filesMoved.some(y => y.id === x.id)))
    }

    async function handleMoveItemsToTrash() {
        toast.done(openedToast);
        setOpenedToast(null);
        const movePromise = handleMoveGivenItemsToTrash(selectedFiles)
        setSelectedFiles([]);
        await movePromise;
    }

    async function toggleSelected(file) {
        setSelectedFiles(prevValue => {
            if (prevValue.some(x => x.id === file.id)) {
                const index = prevValue.findIndex(x => x.id === file.id)
                if (index === -1) {
                    return prevValue;
                }
                const aux = [...prevValue]
                aux.splice(index, 1);
                return aux;
            } else {
                return [...prevValue, file]
            }
        });
    }

    async function onClickFile(file) {
        if (selectedFiles.length > 0) {
            return;
        }
        onOpenFile(file);
    }

    function selectAllFiles() {
        setSelectedFiles(prevState => {
            const aux = [...prevState].filter(x => !files.some(y => x.id === y.id));
            aux.push(...files);
            return aux;
        });
    }

    function selectAllFolders() {
        setSelectedFiles(prevState => {
            const aux = [...prevState].filter(x => !folders.some(y => x.id === y.id));
            aux.push(...folders);
            return aux;
        });
    }

    function cancelSelected() {
        if (openedToast) {
            toast.dismiss(openedToast);
        }
        setOpenedToast(null);
        setSelectedFiles([]);
        setMovingItems(null);
    }

    async function onClickFolder(folder) {
        if (movingItems) {
            toast.done(openedToast);
            setOpenedToast(null);
            const movePromise = handleMoveGivenItemsToFolder(selectedFiles, folder);
            cancelSelected();
            await movePromise;
            return;
        } else if (selectedFiles.length > 0) {
            return;
        }
        onChangeFolder(folder);
    }


    async function handleGoBack(folder) {
        if (movingItems) {
            toast.done(openedToast);
            setOpenedToast(null);
            const movePromise = handleMoveGivenItemsToFolder(selectedFiles, folder);
            cancelSelected();
            await movePromise;
            return;
        } else if (selectedFiles.length > 0) {
            return;
        }
        onGoBack();
    }


    async function handleRightClick(event, thing) {
        event.preventDefault();
        event.stopPropagation();

        const linkMenu = document.getElementById("link-menu");
        const scrollContainer = document.getElementById('home__scrollContainer');

        const menuWidth = contextualMenu.current.offsetWidth;
        const menuHeight = isMobileDevice() ? 307 : 247;
        const maxLeft = scrollContainer.clientWidth - menuWidth;
        const maxTop = scrollContainer.clientHeight + scrollContainer.scrollTop - menuHeight;
        const left = Math.min(event.clientX - (linkMenu?.clientWidth || 0), maxLeft);
        const top = Math.min(event.clientY, maxTop);

        if (activeContext?.id === thing.id) {
            setShowContextMenu(false);
            setActiveContext(null);
            contextualMenu.current.style.left = `-1000px`;
            contextualMenu.current.style.top = `-1000px`;
        } else {
            contextualMenu.current.style.top = `${top}px`;
            contextualMenu.current.style.left = `${left}px`;
            setActiveContext(thing);
            setShowContextMenu(true);
        }
    }

    async function changeNameOfItem(newName, item) {
        setFileChangingName(null);
        if (newName === (item.folderName ?? item.fileName)) {
            return;
        }
        const saveItemInformation = functions.httpsCallable("saveItemInformation");
        if (item.fileName) {
            item.fileName = newName;
            toast.success(intl.formatMessage({id: "drive.change-name.file-success"}))
        } else if (item.folderName) {
            item.folderName = newName;
            toast.success(intl.formatMessage({id: "drive.change-name.folder-success"}))
        }
        await saveItemInformation({item});
    }

    async function itemOnDragOverFolder(item, folder) {
        await handleMoveGivenItemsToFolder([item], folder);
        setDraggingItem(null);
    }

    const paths = useMemo(() => {
        let cleanPath = location.pathname;
        if (cleanPath.includes("/file/")) {
            cleanPath = cleanPath.split("/file/")[0];
        }
        return cleanPath.split("/").filter(Boolean);
    }, [location.pathname]);

    return (
        <div>
            {loading &&
                <div className="d-flex flex-column align-items-center mt-5"><Spinner></Spinner></div>}
            {!loading && (files.length > 0 || folders.length > 0) &&
                <div className="list-group fileTable__filesRows"
                     onContextMenu={e => {
                         e.preventDefault();
                         e.stopPropagation();
                     }}>
                    {paths.length > 1 &&
                        <FileRow isFolder={true} params={{folderName: paths.at(-2)}} onClick={handleGoBack}
                                 goBack={true} setDraggingItem={setDraggingItem} movingItems={movingItems}
                                 draggingItem={draggingItem} onDragOverFolder={itemOnDragOverFolder}
                                 uploadUtils={uploadUtils}/>}
                    {draggingAnything && !draggingItem &&
                        <FileRow isFolder={true} params={folderTree[folderTree.length - 1]} onClick={handleGoBack}
                                 goBack={false} setDraggingItem={setDraggingItem} movingItems={movingItems}
                                 draggingItem={draggingItem} onDragOverFolder={itemOnDragOverFolder}
                                 uploadUtils={uploadUtils} thisFolder={true}/>}
                    {folders.map(folder => <FileRow selected={selectedFiles.some(x => x.id === folder.id)}
                                                    isFolder={true} loading={loadingFiles.some(x => x.id === folder.id)}
                                                    onToggleSelected={toggleSelected} onClick={onClickFolder}
                                                    key={folder.id} params={folder} showOptions={true}
                                                    disabled={movingItems && selectedFiles.some(x => x.id === folder.id)}
                                                    changeName={fileChangingName?.id === folder.id}
                                                    movingItems={movingItems}
                                                    active={folder.id === activeContext?.id} draggable={true}
                                                    onRightClick={e => handleRightClick(e, folder)}
                                                    uploadUtils={uploadUtils}
                                                    onNameSaved={changeNameOfItem} setDraggingItem={setDraggingItem}
                                                    draggingItem={draggingItem} onDragOverFolder={itemOnDragOverFolder}>

                    </FileRow>)}
                    {files.map(file => <FileRow selected={selectedFiles.some(x => x.id === file.id)} isFolder={false}
                                                loading={loadingFiles.some(x => x.id === file.id) || !file.storeUrl}
                                                onToggleSelected={toggleSelected} onClick={onClickFile}
                                                disabled={movingItems}
                                                changeName={fileChangingName?.id === file.id} showOptions={true}
                                                key={file.id} params={file} active={file.id === activeContext?.id}
                                                onRightClick={e => handleRightClick(e, file)} draggable={true}
                                                onNameSaved={changeNameOfItem} setDraggingItem={setDraggingItem}
                                                draggingItem={draggingItem} onDragOverFolder={itemOnDragOverFolder}>
                    </FileRow>)}
                </div>
            }

            {!(!loading && (files.length > 0 || folders.length > 0)) &&
                <div>
                    <div className="list-group fileTable__filesRows mb-3">

                        {paths.length > 1 &&
                            <FileRow isFolder={true} params={{folderName: paths.at(-2)}}
                                     onClick={handleGoBack} goBack={true}/>}

                        {draggingAnything && !draggingItem &&
                            <FileRow isFolder={true} params={folderTree[folderTree.length - 1]} onClick={handleGoBack}
                                     goBack={false} setDraggingItem={setDraggingItem} movingItems={movingItems}
                                     draggingItem={draggingItem} onDragOverFolder={itemOnDragOverFolder}
                                     uploadUtils={uploadUtils} thisFolder={true}/>}
                    </div>
                    <div className="alert alert-info" role="alert">
                        <FormattedMessage id="drive.no-files"/>
                    </div>
                </div>
            }
            <div className={"fileTable__contextMenu " + (isMobileDevice() && "fileTable__contextMenu-sm")}
                 ref={contextualMenu} onContextMenu={e => {
                e.preventDefault();
                e.stopPropagation();
            }} onMouseUp={e => {
                e.preventDefault();
                e.stopPropagation();
            }} style={{left: "-1000px", top: "-1000px", zIndex: 12}}>
                <div className="list-group">
                    <li className="list-group-item text-muted">
                        <div className="truncated-text">
                            <span>{activeContext?.fileName ?? activeContext?.folderName}</span>
                        </div>
                    </li>
                    <button type="button" className="list-group-item list-group-item-action fileTable__button-context"
                            onClick={e => {
                                contextualMenu.current.style.left = `-1000px`;
                                contextualMenu.current.style.top = `-1000px`;
                                if (activeContext.fileName) {
                                    onClickFile(activeContext);
                                } else {
                                    onClickFolder(activeContext);
                                }
                                setShowContextMenu(false);
                                setActiveContext(null);
                            }}>
                        <FormattedMessage id="drive.contextMenu.open-item"/>
                        <i className="fa-solid fa-arrow-up-right-from-square ms-2"></i>
                    </button>
                    {activeContext?.storeUrl &&
                        <button type="button"
                                className="list-group-item list-group-item-action fileTable__button-context"
                                onClick={e => {
                                    contextualMenu.current.style.left = `-1000px`;
                                    contextualMenu.current.style.top = `-1000px`;
                                    addFileToQueue(activeContext);
                                    setShowContextMenu(false);
                                    setActiveContext(null);
                                }}>
                            <FormattedMessage id="file-viewer.download-file"/>
                            <i className="fa-solid fa-download ms-2"></i>
                        </button>}
                    <button type="button"
                            className="list-group-item list-group-item-action fileTable__button-context"
                            onClick={
                                async e => {
                                    contextualMenu.current.style.left = `-1000px`;
                                    contextualMenu.current.style.top = `-1000px`;
                                    setFileChangingName(activeContext);
                                    setShowContextMenu(false);
                                    setActiveContext(null);
                                }
                            }>
                        <FormattedMessage id="drive.contextMenu.change-name"/>
                        <i className="fa-solid fa-pen-to-square ms-2"></i>
                    </button>
                    <button type="button"
                            className="list-group-item list-group-item-action fileTable__button-context text-danger"
                            onClick={
                                async e => {
                                    contextualMenu.current.style.left = `-1000px`;
                                    contextualMenu.current.style.top = `-1000px`;
                                    setSelectedFiles(prevState => prevState.filter(x => x.id !== activeContext.id))
                                    const promise = handleMoveGivenItemsToTrash([activeContext])
                                    setShowContextMenu(false);
                                    setActiveContext(null);
                                    await promise;
                                }
                            }>
                        <FormattedMessage id="drive.contextMenu.delete-item"/><i className="fa-solid fa-trash ms-2"></i>
                    </button>
                    <button type="button"
                            className="list-group-item list-group-item-action fileTable__button-context"
                            onClick={
                                async e => {
                                    contextualMenu.current.style.left = `-1000px`;
                                    contextualMenu.current.style.top = `-1000px`;
                                    setShowContextMenu(false);
                                    setActiveContext(null);
                                }
                            }>
                        <FormattedMessage id="modal.close"/><i className="fa-solid fa-times ms-2"></i>
                    </button>
                </div>
            </div>
            <ConfirmationModal
                title={intl.formatMessage({id: "drive.delete-selected.confirm-trash"})}
                message={intl.formatMessage({id: "drive.delete-selected.confirm-trash.message"})}
                btnClass="btn-danger" modalName={"confirmMoveTrash"} onClose={res => {
                if (res) {
                    handleMoveItemsToTrash();
                } else {
                    cancelSelected();
                }
            }}/>
            <UploadUtils ref={uploadUtils}/>
        </div>
    )
}

export default FilesTable;
